import type { ShouldRevalidateFunction } from '@remix-run/react';
import { json, type LoaderFunctionArgs } from '@remix-run/node';
import { querySearchServiceSearch } from '@modules/search';
import { DEFAULT_SOURCE_FILTER } from '@modules/search/util/filter-url-helpers';

export const FEATURED_RESULTS_ACTION = '/actions/search/featured-results';

/**
 * API endpoint to get the top featured/trending results to generate search
 * suggestions for users.
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { logger } = context;

    try {
        const featuredItems = await querySearchServiceSearch({
            context,
            queryParams: {
                filters: {
                    visibilities: ['InLibrary'],
                },
                sourceFilter: DEFAULT_SOURCE_FILTER,
                sortBy: 'featured',
                size: 5,
            },
        });

        return json({
            results:
                featuredItems?.hits.map((item) => ({
                    type: item.PType!,
                    title: item.Title!,
                    link: item.Link,
                })) ?? [],
        });
    } catch (error) {
        logger.error('Error in /actions/search/featured-results', { error });
        return json(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
